module.exports = __webpack_public_path__ + "static/media/Apple iPad Pro 13\" Space Gray - Portrait.d996b3b4.png";